
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { useCookies } from "react-cookie";
import { Cookies } from "react-cookie";
import { Spin } from "antd";


import { SuspenseImg } from "../../SuspenseImage/SuspenseImage";
import ErrorModal from "../ErrorModal/ErrorModal";
import NonHeaderFlow from "../NonHeaderFlow/NonHeaderFlow";
import HeaderFlow from "../HeaderFlow/HeaderFlow";

const cookiesNew = new Cookies();
const ShowLoginInput = ({
  logo,
  serviceType,
  price,
  ani,
  service_id,
  product_id,
  clickid,
}) => {
  const [cookies, setCookie] = useCookies(["toonflix"]);
  const [isFrench, setFrench] = useState(true);
  const navigate = useNavigate();
  const [isError, setIsError] = useState("");
  const [ShowTimer, setShowTimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPack, setShowPack] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [msisdn, setMSISDN] = useState("");
  const [trxId, setTRXID] = useState("");
  const [evinaData, setEvinaData] = useState({ tid: '', ti: '', ts: '' });

  const flowType = cookies?.toonflix?.ani === "null" ? "PIN" : "HE";

  const formSubmit = async (values) => {
    try {
      setMSISDN(values.msisdn);
      const response = await axios.post(
        "http://api.dzi.toon-flix.com/sendsms",
        { ani: values.msisdn, type: "otp", serviceType: "TOONFLIX" }
      );
      setLoading(false);
      setShowPack(false);
      setShowOTP(true);
      setTRXID(response.data.txCode);
    } catch (err) {
      console.log(err.response);
    }
  };

  const OTPSubmit = async (values) => {
    try {
      const response = await axios.post(
        "http://api.dzi.toon-flix.com/verifyOTP/verify",
        {
          ani: msisdn,
          inputOTP: values.otp,
          trxId: trxId,
          serviceType: "TOONFLIX",
        }
      );
      setShowPack(true);
      setShowOTP(false);
    } catch (err) {
      console.log("OTP verification failed", err.response?.data);
    }
  };

  const packSubmit = async (values, evinaData, flowType) => {
    const { tid, ti, ts } = evinaData;
    const userAgent = navigator.userAgent;
    console.log("VALUES",values , "evina data",evinaData , "flowType" , flowType)
    const pack = values.pack === "daily" || values.pack === "تونفليكس ديلي"
      ? "Toonflix Daily"
      : "Toonflix Weekly";

    try {
      const response = await axios.get(
        `http://api.dzi.toon-flix.com/user/register?ani=${msisdn === "" ? cookies.toonflix.ani : msisdn}&isSubscribe=true&pack_type=${pack}&service_type=TOONFLIX&lang=${isFrench ? "FR" : "AR"}&mode=web&tid=${tid}&ti=${ti}&ts=${ts}&flow=${flowType}&userAgent=${userAgent}`
      );
      setCookie(
        "toonflix",
        {
          ani: msisdn === "" ? cookies.toonflix.ani : msisdn,
          status: 1,
          lang: `${isFrench ? "FR" : "AR"}`,
        },
        { path: "/" }
      );
      navigate(
        `/landing/toonflix/redirect/?ani=${msisdn === "" ? cookies.toonflix.ani : msisdn}&status=1&lang=${isFrench ? "FR" : "AR"}`
      );
    } catch (err) {
      console.log(err.response);
    }
  };

  return (
    <ShowLoginInputStyled>
      <div className="inner-items">
        <SuspenseImg src={logo} alt="logo" />
        <h2></h2>
        {cookies?.toonflix?.ani === "null" ? (
          <NonHeaderFlow
            formSubmit={formSubmit}
            showPack={showPack}
            OTPSubmit={OTPSubmit}
            showOTP={showOTP}
            packSubmit={(values, evinaData) => packSubmit(values, evinaData, flowType)}
            isFrench={isFrench}
            setFrench={setFrench}
          />
        ) : (
          <HeaderFlow
            formSubmit={formSubmit}
            showPack={true}
            OTPSubmit={OTPSubmit}
            showOTP={false}
            packSubmit={(values, evinaData) => packSubmit(values, evinaData, flowType)}
            ani={cookies?.toonflix?.ani}
            isFrench={isFrench}
            setFrench={setFrench}
          />
        )}
        {isError && (
          <ErrorModal
            message={isError}
            OnCancel={() => setIsError("")}
            visible={isError ? true : false}
            ShowTimer={ShowTimer}
          />
        )}
        {loading && (
          <div className="loader-container">
            <Spin size="large" />
          </div>
        )}
      </div>
    </ShowLoginInputStyled>
  );
};

export default ShowLoginInput;

const ShowLoginInputStyled = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(135deg, #52e5e7 10%, #130cb7 100%);
  .custom-button {
    border-radius: 8px;
    background-color: #799f0c;
    font-weight: 800;
    margin-top: 20px;
    text-align: center;
    display: block;
    margin: 0 auto;
  }
  .inner-items {
    height: 80%;
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    img {
      width: 50%;
    }
  }
  h2 {
    color: white;
    padding: 10px;
    font-weight: 800;
  }
  .footer-info {
    margin-top: 100px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    h3 {
      color: white;
    }
  }
`;


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import styled from "styled-components";
// import { useCookies } from "react-cookie";
// const cookiesNew = new Cookies();

// import { SuspenseImg } from "../../SuspenseImage/SuspenseImage";
// import ErrorModal from "../ErrorModal/ErrorModal";
// import NonHeaderFlow from "../NonHeaderFlow/NonHeaderFlow";
// import HeaderFlow from "../HeaderFlow/HeaderFlow";

// const ShowLoginInput = ({
//   logo,
//   serviceType,
//   price,
//   ani,
//   service_id,
//   product_id,
//   clickid,
// }) => {
//   const [cookies, setCookie] = useCookies(["toonflix"]);
//   const [isFrench, setFrench] = useState(true);

//   const navigate = useNavigate();
//   const [isError, setIsError] = useState("");
//   const [ShowTimer, setShowTimer] = useState(false);

//   const [loading, setLoading] = useState(false);
//   // either to show pack or not
//   const [showPack, setShowPack] = useState(false);
//   const [showOTP, setShowOTP] = useState(false);
//   const [msisdn, setMSISDN] = useState("");
//   const [trxId, setTRXID] = useState("");

//   console.log("SHOW INPUT LOGIN ", isFrench);

//   const formSubmit = async (values) => {
//     console.log("values ani is ", values.ani);
//     if (values.msisdn === "12345678")
//       return navigate("/landing/toonflix/redirect");

//     console.log("values ", values);
//     try {
//       setMSISDN(values.msisdn);

//       const response = await axios.post(
//         "http://api.dzi.toon-flix.com/sendsms",
//         {
//           ani: values.msisdn,
//           type: "otp",
//           serviceType: "TOONFLIX",
//         }
//       );
//       setLoading(false);
//       console.log("response ", response);
//       setShowPack(false);
//       setShowOTP(true);
//       setTRXID(response.data.txCode);

//       // const response = await axios.post(
//       //   // `http://localhost:6247/user/subscribe`,
//       //   `/user/subscribe`,
//       //   {
//       //     ani: values.msisdn,
//       //     isSubscribe: true,
//       //     pack_type: values.pack,
//       //     service_name: "TOONFLIX",
//       //   }
//       // );
//       // console.log("RESPONSE  ", response.data);
//       // if (response.data.message.statusMessage === "Subscription in progress") {
//       //   setCookie("toonflix", values.msisdn, { path: "/" });
//       //   navigate("/toonflix/redirect");
//       // }
//     } catch (err) {
//       console.log(err.response);
//     }
//   };
//   const OTPSubmit = async (values) => {
//     console.log("values of otp ", values);
//     console.log("values of Msidn ", msisdn);
//     console.log("values of trx ", trxId);

//     try {
//       const response = await axios.post(
//         "http://api.dzi.toon-flix.com/verifyOTP/verify",
//         {
//           ani: msisdn,
//           inputOTP: values.otp,
//           trxId: trxId,
//           serviceType: "TOONFLIX",
//         }
//       );
//       console.log("RESPONSE OTP ", response.data);

//       const responseUser = await axios.get(
//         `http://api.dzi.toon-flix.com/user/register?ani=${msisdn}&isSubscribe=false&pack_type=TOONFLIX&service_type=TOONFLIX`
//       );
//       console.log("user status ", responseUser.data);
//       if (responseUser.data.result === 0) {
//         //check after otp if user is sub or not
//         setShowPack(true);
//         setShowOTP(false);
//       } else {
//         console.log("else flow in invalid otp");
//         // setCookie(
//         //   "toonflix",
//         //   {
//         //     ani: msisdn === "" ? cookies.toonflix.ani : msisdn,
//         //     status: 1,
//         //     lang: `${isFrench ? "FR" : "AR"}`,
//         //   },
//         //   { path: "/" }
//         // );
//         // navigate(
//         //   `/landing/toonflix/redirect/?ani=${
//         //     msisdn === "" ? cookies.toonflix.ani : msisdn
//         //   }&status=1&lang=${isFrench ? "FR" : "AR"}`
//         // );
//         // setCookie("toonflix", msisdn, { path: "/" });
//         setCookie(
//           "toonflix",
//           { ani: msisdn, status: 1, lang: responseUser.data.data[0].lang },
//           { path: "/" }
//         );
//         navigate(
//           `/landing/toonflix/redirect/?ani=${msisdn}&status=1&lang=${responseUser.data.data[0].lang}`
//         );
//       }
//       // setShowPack(true);
//       // setShowOTP(false);
//     } catch (err) {
//       console.log("err.response ", err.response.data);

//       //uncomment below for valid error handle
//       // setIsError(err.response.data.message);
//       // setShowOTP(false);

//       // dummy test begin for valid otp

//       //hit to check user status
//       const response = await axios.get(
//         `http://api.dzi.toon-flix.com/user/register?ani=${msisdn}&isSubscribe=false&pack_type=TOONFLIX&service_type=TOONFLIX`
//       );

//       console.log("user status ", response.data);
//       cookiesNew.remove("toonflix", { path: "/" });
//       setCookie("toonflix", msisdn, { path: "/" });
//       navigate("/landing/toonflix/redirect");
//       if (response.data.result === 0) {
//         //check after otp if user is sub or not
//         setShowPack(true);
//         setShowOTP(false);
//       } else {
//         // setCookie("toonflix", msisdn, { path: "/" });
//         setCookie("toonflix", { ani: msisdn, status: 1 }, { path: "/" });
//         navigate(`/landing/toonflix/redirect/?ani=${msisdn}&status=1`);
//       }
//     }
//   };

//   const packSubmit = async (values) => {
//     console.log(values);
//     let pack =
//       values.pack === "Toonflix quotidien" || values.pack === "تونفليكس ديلي"
//         ? "Toonflix Daily"
//         : "Toonflix Weekly";

//     console.log("pack ", pack);

//     console.log("msisdn ", msisdn === "" ? cookies.toonflix.ani : msisdn);
//     try {
//       const response = await axios.get(
//         `http://api.dzi.toon-flix.com/user/register?ani=${
//           msisdn === "" ? cookies.toonflix.ani : msisdn
//         }&isSubscribe=true&pack_type=${pack}&service_type=TOONFLIX&lang=${
//           isFrench ? "FR" : "AR"
//         }&mode=web`
//       );
//       console.log("respone data ", response.data);
//       // setCookie("toonflix", msisdn === "" ? cookies.toonflix.ani : msisdn, {
//       //   path: "/",
//       // });
//       // setCookie({ ani: cookies.toonflix.ani, status: 1 }, { path: "/" });
//       setCookie(
//         "toonflix",
//         {
//           ani: msisdn === "" ? cookies.toonflix.ani : msisdn,
//           status: 1,
//           lang: `${isFrench ? "FR" : "AR"}`,
//         },
//         { path: "/" }
//       );
//       navigate(
//         `/landing/toonflix/redirect/?ani=${
//           msisdn === "" ? cookies.toonflix.ani : msisdn
//         }&status=1&lang=${isFrench ? "FR" : "AR"}`
//       );
//     } catch (err) {
//       console.log(err.response);
//     }
//   };
//   //   console.log("hi");
//   return (
//     <ShowLoginInputStyled>
//       <div className="inner-items">
//         <SuspenseImg src={logo} alt="logo" />
//         {/* <h2>Subscription Ghc {price} Per / Day</h2> */}
//         <h2></h2>
//         {/* if there is no number */}
//         {cookies.toonflix.ani === "null" ? (
//           <NonHeaderFlow
//             formSubmit={formSubmit}
//             showPack={showPack}
//             OTPSubmit={OTPSubmit}
//             showOTP={showOTP}
//             packSubmit={packSubmit}
//             isFrench={isFrench}
//             setFrench={setFrench}
//           />
//         ) : (
//           <HeaderFlow
//             formSubmit={formSubmit}
//             showPack={true}
//             OTPSubmit={OTPSubmit}
//             showOTP={false}
//             packSubmit={packSubmit}
//             ani={cookies.toonflix.ani}
//             isFrench={isFrench}
//             setFrench={setFrench}
//           />
//         )}

//         {isError ? (
//           <ErrorModal
//             message={isError}
//             OnCancel={() => setIsError("")}
//             visible={isError ? true : false}
//             ShowTimer={ShowTimer}
//           />
//         ) : null}
//       </div>
//     </ShowLoginInputStyled>
//   );
// };

// export default ShowLoginInput;

// const ShowLoginInputStyled = styled.div`
//   position: absolute;

//   height: 100%;
//   width: 100%;
//   background-image: linear-gradient(135deg, #52e5e7 10%, #130cb7 100%);
//   .custom-button {
//     border-radius: 8px;
//     background-color: #799f0c;
//     font-weight: 800;
//     margin-top: 20px;
//     text-align: center;
//     display: block;
//     margin: 0 auto;
//   }
//   .inner-items {
//     height: 80%;
//     width: 100%;
//     padding: 20px;
//     display: flex;

//     justify-content: center;
//     flex-direction: column;
//     align-items: center;
//     img {
//       width: 50%;
//     }
//   }

//   h2 {
//     color: white;
//     padding: 10px;
//     font-weight: 800;
//   }
//   .footer-info {
//     margin-top: 100px;
//     display: flex;
//     width: 100%;
//     justify-content: space-between;
//     h3 {
//       color: white;
//     }
//   }
// `;
